"use client";
import * as React from "react";
const SvgScheduleFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.4 4H7.2v4.8l4.2 2.52.6-.98L8.4 8.2z" }));
export {
  SvgScheduleFilled as default
};
